import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "toolbar" }
const _hoisted_2 = { class: "d-flex px-8" }
const _hoisted_3 = {
  "data-kt-swapper-parent": "{default: '#kt_content_container'}",
  class: "page-title d-flex align-items-center flex-wrap me-3"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "d-flex align-items-center text-dark fs-base fw-bold my-1" }, " Configuración de citas ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "h-20px border-gray-200 border-start mx-4" }, null, -1)
const _hoisted_6 = { class: "breadcrumb breadcrumb-separatorless fw-bold fs-sm my-1" }
const _hoisted_7 = { class: "breadcrumb-item" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bg-gray-200 w-5px h-2px" })
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("li", { class: "breadcrumb-item pe-3 text-dark" }, "Configurar citas", -1)
const _hoisted_10 = {
  key: 0,
  class: "row justify-content-center"
}
const _hoisted_11 = { class: "col-sm-12 col-lg-6 px-5 px-lg-15 py-3 border-divider" }
const _hoisted_12 = { class: "w-100" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h1", { class: "fs-1 fw-bold mb-5" }, "Escoge la ciudad", -1)
const _hoisted_14 = { class: "d-flex flex-column justify-content-center mt-5" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "me-auto fs-base" }
const _hoisted_17 = {
  key: 0,
  class: "text-blue"
}
const _hoisted_18 = {
  key: 1,
  class: "text-gray-700"
}
const _hoisted_19 = {
  key: 0,
  class: "col-sm-12 col-lg-6 px-5 px-lg-0 d-flex d-flex-column justify-content-center align-items-center"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "text-center my-6" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "isax-map-1 fs-5tx text-white" }),
  /*#__PURE__*/_createElementVNode("h3", { class: "my-6 fs-5 fw-bold" }, "Selecciona una ciudad a configurar")
], -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  key: 1,
  class: "col-sm-12 col-lg-6 px-5 px-lg-0 d-flex justify-content-center mt-5"
}
const _hoisted_23 = { class: "form-schedule-width" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-12 d-flex justify-content-between align-items-center" }
const _hoisted_26 = { class: "fs-1 fw-bold mb-0" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "isax-close-circle text-white fs-2x" }, null, -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = { class: "col-12" }
const _hoisted_30 = { class: "fs-5 fw-bold" }
const _hoisted_31 = {
  key: 0,
  class: "col-12 mt-5"
}
const _hoisted_32 = /*#__PURE__*/_createStaticVNode("<div class=\"alert alert-warning bg-light-warning d-flex align-items-center p-5 mb-0\"><span class=\"isax-info-circle fs-1 text-warning me-3 align-self-start\"></span><div class=\"d-flex flex-column\"><h4 class=\"fs-5 fw-bold mb-1 text-warning\">Sin valuadores registrados</h4><span class=\"text-warning fs-base\">No se podrán agendar citas a esta ciudad.</span></div></div>", 1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = { class: "col-12" }
const _hoisted_35 = { class: "fv-row my-6" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-base fw-bold mb-2" }, "Días de visita", -1)
const _hoisted_37 = { class: "list-group list-group-horizontal my-2 w-100" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { class: "row my-6" }
const _hoisted_40 = { class: "col-md-6 col-12" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-base fw-bold mb-2" }, "Horario de inicio", -1)
const _hoisted_42 = { class: "col-md-6 col-12" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-base fw-bold mb-2" }, "Horario de cierre", -1)
const _hoisted_44 = { class: "row my-6" }
const _hoisted_45 = { class: "col-12" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-base fw-bold mb-2" }, "Duración de las citas", -1)
const _hoisted_47 = { class: "d-grid gap-2 d-flex justify-content-end" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("span", { class: "fs-base" }, "Descartar", -1)
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = ["data-kt-indicator"]
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", { class: "fs-base" }, "Guardar cambios", -1)
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_time_select = _resolveComponent("el-time-select")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("ul", _hoisted_6, [
            _createElementVNode("li", _hoisted_7, [
              _createVNode(_component_router_link, {
                to: "/calendario",
                class: "text-muted text-hover-primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Calendario ")
                ]),
                _: 1
              })
            ]),
            _hoisted_8,
            _hoisted_9
          ])
        ])
      ])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_el_input, {
                modelValue: _ctx.search,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                class: "w-100",
                size: "large",
                placeholder: "Buscar una ciudad",
                onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.debounce(_ctx.getCities, 1500)))
              }, {
                suffix: _withCtx(() => [
                  _createVNode(_component_el_icon, { class: "isax-search-normal-1 fs-2" })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cities, (city, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    id: "cities",
                    class: "border-bottom",
                    key: index
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["d-flex justify-content-between align-items-start py-5 px-3 pointer", {
                active: _ctx.selectCity && city.name == _ctx.selectCity.name,
              }]),
                      onClick: ($event: any) => (_ctx.setCity(city))
                    }, [
                      _createElementVNode("div", _hoisted_16, _toDisplayString(city.name), 1),
                      (city.config)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, " Configurado "))
                        : (_openBlock(), _createElementBlock("span", _hoisted_18, " Sin configurar "))
                    ], 10, _hoisted_15)
                  ]))
                }), 128))
              ])
            ])
          ]),
          (!_ctx.selectCity)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
            : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("h1", _hoisted_26, _toDisplayString(_ctx.selectCity.name), 1),
                      _createElementVNode("span", {
                        class: "pointer",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setCity(null)))
                      }, _hoisted_28)
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.selectCity.valuators) + " valuadores activos", 1)
                    ]),
                    (_ctx.selectCity.valuators !== null && _ctx.selectCity.valuators == 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_33))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_34, [
                      _createVNode(_component_el_form, {
                        onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
                        model: _ctx.form,
                        rules: _ctx.rules,
                        ref: "formRef",
                        class: "form-schedule-address"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_35, [
                            _hoisted_36,
                            _createVNode(_component_el_form_item, { prop: "days" }, {
                              default: _withCtx(() => [
                                _createElementVNode("ul", _hoisted_37, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.days, (day, index) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      class: _normalizeClass(["list-group-item p-2 item-day fs-base fw-bold pointer flex-fill", { 'bg-primary': day.active }]),
                                      onClick: ($event: any) => (day.active = !day.active),
                                      key: index
                                    }, _toDisplayString(day.day[0]), 11, _hoisted_38))
                                  }), 128))
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("div", _hoisted_40, [
                              _hoisted_41,
                              _createVNode(_component_el_form_item, {
                                prop: "start_time",
                                class: "w-100"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_time_select, {
                                    class: "w-100",
                                    placeholder: "Hora de inicio",
                                    effect: "dark",
                                    size: "large",
                                    "value-format": "HH:mm",
                                    format: "HH:mm",
                                    start: "08:00",
                                    end: "22:00",
                                    modelValue: _ctx.form.start_time,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.start_time) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_42, [
                              _hoisted_43,
                              _createVNode(_component_el_form_item, {
                                prop: "end_time",
                                class: "w-100"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_time_select, {
                                    class: "w-100",
                                    placeholder: "Hora de cierre",
                                    effect: "dark",
                                    size: "large",
                                    "value-format": "HH:mm",
                                    format: "HH:mm",
                                    start: "08:30",
                                    end: "22:30",
                                    modelValue: _ctx.form.end_time,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.end_time) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("div", _hoisted_45, [
                              _hoisted_46,
                              _createVNode(_component_el_form_item, {
                                prop: "duration",
                                class: "w-100"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    name: "appointmenttime_options",
                                    class: "w-100",
                                    modelValue: _ctx.form.duration,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.duration) = $event)),
                                    placeholder: "Selecciona la duración",
                                    effect: "dark",
                                    size: "large"
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appointmenttime_options, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.value,
                                          label: item.label,
                                          value: item.value,
                                          disabled: item.disabled
                                        }, null, 8, ["label", "value", "disabled"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_47, [
                            _createElementVNode("button", {
                              class: "btn btn-lg btn-secondary",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setCity(null)))
                            }, _hoisted_49),
                            _createElementVNode("button", {
                              "data-kt-indicator": _ctx.loading ? 'on' : null,
                              class: "btn btn-lg btn-primary",
                              type: "submit"
                            }, _hoisted_52, 8, _hoisted_50)
                          ])
                        ]),
                        _: 1
                      }, 8, ["model", "rules"])
                    ])
                  ])
                ])
              ]))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_53, "Cargando...."))
  ], 64))
}